/*
 * @Description: 
 * @Author: Rfan
 * @Date: 2020-01-14 11:45:20
 * @LastEditTime: 2024-12-20 17:12:02
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/components/Layout';

Vue.use(VueRouter)

const routes = [
{
  path: '/',
  redirect: '/download'
},
{
  path: '/download',
  component: () => import(/* webpackChunkName: "Home" */ '@/views/download'),
},
{
  path: '/agreement',
  name: 'Agreement',
  component: Layout,
  redirect: '/agreement/service',
  meta: {
    title: ' '
  },
  children: [
    {
      path: 'service',
      name: 'Service',
      component: () => import(/* webpackChunkName: "Service" */ '@/views/agreement/Service'),
      meta: {
        title: '画世界Pro用户协议'
      }
    },
    {
      path: 'privacy',
      name: 'Privacy',
      component: () => import(/* webpackChunkName: "Privacy" */ '@/views/agreement/Privacy'),
      meta: {
        title: '画世界Pro隐私政策'
      }
    }
  ]
},

{
  path: '/404',
  component: () => import(/* webpackChunkName: "404" */ '@/views/error-page/404'),
  hidden: true
},
// 404 page must be placed at the end !!!
{ path: '*', redirect: '/' }

]

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
